import React, { useState, useEffect } from "react";
import { Button, Form } from "semantic-ui-react";
import { BasicModal } from "ceco-modal";
import { Recipe } from "ceicons";
import { isEmpty, split } from "lodash";
import graphql from "babel-plugin-relay/macro";
import { createFragmentContainer } from "react-relay";
import { toast } from "react-toastify";
import { commitMutation } from "react-relay";
import environment from "../../../environment";
import { useTranslation } from "ceco-polyglot";

function IngredientRecipeModal(props) {
  const {
    trigger,
    edit,
    refetchData,
    ingredient,
    section,
    recipeId,
    allIngredients,
    allUnitMeasure,
  } = props;
  const [modalOpen, setModalOpen] = useState(false);
  const [ingredientsList, setIngredientsList] = useState([]);
  const [unitsList, setUnitsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const t = useTranslation();

  useEffect(() => {
    setIngredientsList(
      allIngredients.edges.map((ing) => {
        return { key: ing.node.id, text: ing.node.name, value: ing.node.name };
      })
    );
  }, [allIngredients]);

  useEffect(() => {
    setUnitsList(
      allUnitMeasure.edges.map((unit) => {
        return {
          key: unit.node.id,
          text: unit.node.description,
          value: unit.node.id,
        };
      })
    );
  }, [allUnitMeasure]);

  function addIngredientToRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
        recipe: recipeId,
        ingredient: formData.ingredient ? formData.ingredient : "",
        section: formData.section?.id,
        unity: formData.typeQty === "fraction" ? "" : formData?.unityF,
        qty:
          formData.typeQty === "fraction"
            ? formData.numerator / formData.denominator
            : formData?.qty,
        comments: formData.comments,
        fraction:
          formData.typeQty === "fraction"
            ? `${formData.numerator}/${formData.denominator}`
            : null,
      };

      commitMutation(environment, {
        mutation: section
          ? ingredientRecipeModalSection_create_Mutation
          : ingredientRecipeModal_create_Mutation,
        variables,

        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
      });
    });
  }

  function editIngredientRecipe() {
    return new Promise((resolve, reject) => {
      const variables = {
        ...formData,
        recipe: recipeId,
        ingredient: formData.ingredient,
        section: formData.section?.id,
        unity: formData.typeQty === "fraction" ? "" : formData?.unityF,
        qty:
          formData.typeQty === "fraction"
            ? formData.numerator / formData.denominator
            : formData?.qty,
        comments: formData.comments,
        fraction:
          formData.typeQty === "fraction"
            ? `${formData.numerator}/${formData.denominator}`
            : null,
      };

      commitMutation(environment, {
        mutation: ingredientRecipeModal_update_Mutation,
        variables,
        onCompleted(response, errors) {
          if (errors) {
            reject(errors);
          }
          resolve(response);
        },
        onError(error) {
          reject(error);
        },
        // updater: (store) => {
        //   const payload = store.getRootField("recipeIngredientCreate");
        //   console.log("payload");
        // },
      });
    });
  }

  const addNewItemIngredient = ({ value }) => {
    setIngredientsList([
      ...ingredientsList,
      { key: value, text: value, value: value },
    ]);
  };
  const handleChangeIngredient = (e, { value }) => {
    setFormData({
      ...formData,
      ingredient: value,
    });
  };
  const handleChangeUnits = (e, data) => {
    const { value } = data;
    setFormData({
      ...formData,
      unityF: value,
    });
  };
  const handleChangeType = (e, data) => {
    const { value } = data;
    setFormData({
      ...formData,
      typeQty: value,
    });
  };

  function handleChange(evt) {
    const { value, name } = evt.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  }

  const validateForm = () => {
    let errors = {};
    let validate = true;

    if (!formData.ingredient) {
      errors = { ...errors, ingredient: t("form.errorRequired") };
    }

    if (formData.typeQty === "fraction") {
      if (!formData.numerator) {
        errors = {
          ...errors,
          numerator: t("form.errorNumerator"),
        };
      }
      if (!formData.denominator) {
        errors = {
          ...errors,
          denominator: t("form.errorDenominator"),
        };
      }
    } else {
      if (formData.unityF) {
        if (!formData.qty) {
          errors = {
            ...errors,
            unity: t("form.errorMesaggeRecipeIngredientQty"),
          };
        }
      }
    }

    if (!isEmpty(errors)) {
      validate = false;
    }

    setFormErrors(errors);
    return validate;
  };

  const onSubmit = async () => {
    if (validateForm()) {
      const action = !edit ? addIngredientToRecipe : editIngredientRecipe;
      const msg = !edit
        ? t("message.added_ingredient")
        : t("message.edited_ingredient");
      action()
        .then((a) => {
          toast.success(msg);
          setModalOpen(false);
          setLoading(false);
          refetchData();
        })
        .catch((e) => {
          if (Array.isArray(e)) {
            toast.error(e[0].message);
          } else {
            toast.error(e?.errors[0]?.message);
          }
        });
    }
  };

  return (
    <BasicModal
      size="small"
      className="single-button"
      title={
        <div className="modalTitle">
          <Recipe />
          {edit
            ? t("modalTitle.editIngredient")
            : t("modalTitle.addIngredient")}
        </div>
      }
      trigger={React.cloneElement(trigger, {
        onClick: (e) => {
          e.preventDefault();
          setModalOpen(true);

          edit
            ? setFormData({
                ...ingredient,
                id: ingredient.id,
                ingredient: ingredient.ingredient.name,
                section: section ? section : "",
                unityF: ingredient?.unityF?.id ? ingredient.unityF.id : "",
                qty: ingredient.qty,
                numerator: split(ingredient.fraction, "/")[0],
                denominator: split(ingredient.fraction, "/")[1],
                typeQty: ingredient.fraction ? "fraction" : "numeric",
              })
            : setFormData({
                unityF: "",
                qty: "0",
                section: section ? section : "",
                typeQty: "numeric",
              });
        },
      })}
      actions={
        <Button
          type="submit"
          disabled={loading}
          onClick={() => {
            onSubmit();
          }}
          primary
        >
          {t("button.save")}
        </Button>
      }
      open={modalOpen}
      closeOnEscape={modalOpen}
      closeOnDimmerClick={modalOpen}
      onModalClose={() => setModalOpen(false)}
      showCloseButton={true}
    >
      <Form>
        <Form.Field>
          <Form.Dropdown
            placeholder={t("form.ingredient")}
            label={t("form.ingredient")}
            name="ingredient"
            error={formErrors && formErrors["ingredient"]}
            search
            value={formData.ingredient}
            noResultsMessage={t("message.noResultsIngredients")}
            selection
            onChange={handleChangeIngredient}
            options={ingredientsList}
            additionPosition="top"
            additionLabel={t("dropdown.newIngredient")}
            allowAdditions={true}
            onAddItem={(e, data) => {
              addNewItemIngredient(data);
            }}
            required
          />
        </Form.Field>
        <Form.Group widths={3}>
          <Form.Field>
            <Form.Dropdown
              placeholder={t("form.typeQty")}
              label={t("form.typeQty")}
              name="unity"
              search
              onChange={handleChangeType}
              value={formData.typeQty}
              noResultsMessage={t("message.noResultsUnits")}
              selection
              options={[
                { key: "1", text: t("form.numeric"), value: "numeric" },
                { key: "2", text: t("form.fraction"), value: "fraction" },
              ]}
            />
          </Form.Field>
          {formData.typeQty === "fraction" ? (
            <>
              <Form.Field>
                <Form.Input
                  key="numerator"
                  name="numerator"
                  type="number"
                  min={1}
                  error={formErrors && formErrors["numerator"]}
                  defaultValue={formData.numerator}
                  label={t("form.numerator")}
                  placeholder={t("form.numerator")}
                  onChange={handleChange}
                />
              </Form.Field>
              <Form.Field>
                <Form.Input
                  key="denominator"
                  name="denominator"
                  type="number"
                  min={2}
                  error={formErrors && formErrors["denominator"]}
                  defaultValue={formData.denominator}
                  label={t("form.denominator")}
                  placeholder={t("form.denominator")}
                  onChange={handleChange}
                />
              </Form.Field>
            </>
          ) : (
            <>
              <Form.Field>
                <Form.Input
                  key="qty"
                  name="qty"
                  type="number"
                  min={1}
                  error={formErrors && formErrors["qty"]}
                  defaultValue={Number(formData.qty).toFixed(2)}
                  label={t("form.quantity")}
                  placeholder={t("form.quantity")}
                  onChange={handleChange}
                />
              </Form.Field>
              <Form.Field>
                <Form.Dropdown
                  key="units"
                  placeholder={t("form.units")}
                  label={t("form.units")}
                  name="unity"
                  error={formErrors && formErrors["unity"]}
                  search
                  onChange={handleChangeUnits}
                  value={formData.unityF}
                  noResultsMessage={t("message.noResultsUnits")}
                  selection
                  clearable
                  options={unitsList}
                />
              </Form.Field>
            </>
          )}
        </Form.Group>

        <Form.Field widths={1}>
          <Form.TextArea
            onChange={handleChange}
            defaultValue={formData.comments}
            label={t("form.comments")}
            name="comments"
          />
        </Form.Field>
      </Form>
      <p className="required-modal">{t("form.required")}</p>
    </BasicModal>
  );
}

const ingredientRecipeModal_create_Mutation = graphql`
  mutation IngredientRecipeModalCreateMutation(
    $ingredient: String!
    $recipe: ID!
    $unity: ID
    $qty: String
    $comments: String
    $fraction: String
  ) {
    recipeIngredientCreate(
      input: {
        ingredient: $ingredient
        recipe: $recipe
        unity: $unity
        qty: $qty
        comments: $comments
        fraction: $fraction
      }
    ) {
      recipe {
        ingredient {
          id
          name
        }
      }
    }
  }
`;
const ingredientRecipeModalSection_create_Mutation = graphql`
  mutation IngredientRecipeModalSectionCreateMutation(
    $ingredient: String!
    $recipe: ID!
    $unity: ID
    $qty: String
    $comments: String
    $section: ID
    $fraction: String
  ) {
    recipeIngredientCreate(
      input: {
        ingredient: $ingredient
        recipe: $recipe
        unity: $unity
        qty: $qty
        comments: $comments
        section: $section
        fraction: $fraction
      }
    ) {
      recipe {
        ingredient {
          id
          name
        }
      }
    }
  }
`;
const ingredientRecipeModal_update_Mutation = graphql`
  mutation IngredientRecipeModalUpdateMutation(
    $id: ID!
    $ingredient: String!
    $recipe: ID!
    $unity: ID
    $qty: String
    $comments: String
    $fraction: String
  ) {
    recipeIngredientUpdate(
      input: {
        id: $id
        ingredient: $ingredient
        recipe: $recipe
        unity: $unity
        qty: $qty
        comments: $comments
        fraction: $fraction
      }
    ) {
      recipe {
        ingredient {
          id
          name
        }
      }
    }
  }
`;

export default createFragmentContainer(IngredientRecipeModal, {
  allIngredients: graphql`
    fragment IngredientRecipeModal_allIngredients on IngredientNodeConnection {
      edges {
        node {
          id
          name
        }
      }
    }
  `,
  allUnitMeasure: graphql`
    fragment IngredientRecipeModal_allUnitMeasure on UnitMeasureNodeConnection {
      edges {
        node {
          description
          code
          id
        }
      }
    }
  `,
});
